import jalaali from 'jalaali-js';

export function convertToJalali(date) {
  const gregorianDate = new Date(date);

  const jalaliDate = jalaali.toJalaali(gregorianDate.getFullYear(), gregorianDate.getMonth() + 1, gregorianDate.getDate());

  let formattedDate = `${jalaliDate.jy}/${jalaliDate.jm}/${jalaliDate.jd}`;

  let adjustedHours = gregorianDate.getUTCHours() + 3;
  let adjustedMinutes = gregorianDate.getUTCMinutes() + 30;

  if (adjustedMinutes >= 60) {
    adjustedMinutes -= 60;
    adjustedHours += 1;
  }

  if (adjustedHours >= 24) {
    adjustedHours -= 24;
  }

  const hasTime = adjustedHours || adjustedMinutes || gregorianDate.getUTCSeconds();

  if (hasTime) {
    const hours = String(adjustedHours).padStart(2, '0');
    const minutes = String(adjustedMinutes).padStart(2, '0');
    formattedDate += ` - ${hours}:${minutes}`;
  }

  return formattedDate;
}


export function getIsoDateWithoutTime(offset = 0) {
  // گرفتن تاریخ به وقت تهران بدون ساعت
  const formatter = new Intl.DateTimeFormat("en", {
    timeZone: "Asia/Tehran",
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });

  const parts = formatter.formatToParts(new Date());
  const year = Number(parts.find(p => p.type === "year").value);
  const month = Number(parts.find(p => p.type === "month").value);
  const day = Number(parts.find(p => p.type === "day").value);

  const localDate = new Date(year, month - 1, day + offset);

  return localDate.toISOString().split("T")[0];
}

export function toJalaliString(isoDate) {
  const [year, month, day] = isoDate.split('-').map(Number);

  const { jy, jm, jd } = jalaali.toJalaali(year, month, day);

  return `${jy}/${jm.toString().padStart(2,'0')}/${jd.toString().padStart(2,'0')}`;
}